export const EVENT = {
  LOGIN: 'connect_login',
  PAYER_INFO_SUBMIT: 'connect_payerInfoSubmit',
  RECIPIENT_INFO_SUBMIT: 'connect_recipientInfoSubmit',
  DELIVERY_METHOD_SUBMIT: 'connect_deliveryMethodSubmit',
  PAYMENT_METHOD_SUBMIT: 'connect_paymentMethodSubmit',
  DETAILS_SUBMIT: 'connect_detailsSubmit',
  PAYMENT_SUBMIT: 'connect_paymentSubmit',
}
